import { applyMiddleware, createStore, Middleware } from 'redux'
import reduxThunk from 'common/utils/reduxThunk'
import { createLogger } from 'redux-logger'
import { isBrowser, isDev } from 'common/utils'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'

declare const module: any
export default function configureStore(initialState?) {
  const middlewares: Middleware[] = [reduxThunk]

  if (isDev && isBrowser && process.env.USE_REDUX_LOG) {
    const reduxLogger = createLogger({
      duration: true,
      // diff: true,
    })

    middlewares.push(reduxLogger)
  }

  const store = createStore(
    require(`${process.env.PROJECT_NAME}/reducer`).default,
    initialState,
    composeWithDevTools(applyMiddleware(...middlewares)),
  )

  if (module.hot) {
    const reducerPath = `${process.env.PROJECT_NAME}/reducer`
    module.hot.accept(reducerPath, () => {
      const nextRootReducer = require(`${process.env.PROJECT_NAME}/reducer`).default
      store.replaceReducer(nextRootReducer)
    })
  }

  return store
}
